/**
* @prop --uic-flyout-bg-color: flyout background color
* @prop --uic-flyout-content-min-height: minimum height of the content panel
* @prop --uic-flyout-content-padding: inner padding of the content panel
* @prop --uic-flyout-shadow: box-shadow dropped by the flyout
* @prop --uic-flyout-width: width of the flyout
* @prop --uic-flyout-max-width: max width of the flyout
* @prop --uic-flyout-z-index: zIndex of the flyout
*/
uic-flyout {
  background: var(--uic-flyout-bg-color);
  box-shadow: var(--uic-flyout-shadow);
  box-sizing: border-box;
  display: none;
  max-width: var(--uic-flyout-max-width, 100%);
  pointer-events: none;
  position: absolute;
  top: 100%;
  width: var(--uic-flyout-width);
  z-index: var(--uic-flyout-z-index);

  hr {
    border: 1px solid var(--uic-color-grey2);
    border-bottom-width: 0;
    margin: 1em 0;
  }
}

.uic-flyout {
  &__content {
    box-sizing: border-box;
    max-height: calc(100vh - var(--uic-header-height) - 70px);
    min-height: var(--uic-flyout-content-min-height);
    overflow-y: auto;
    padding: var(--uic-flyout-content-padding);
  }

  &--opened {
    display: block;
    pointer-events: auto;
  }

  &--left {
    left: 0;
    right: auto;
  }

  &--right {
    left: auto;
    right: 0;
  }
}
